<template>
  <div class="app_phone__input">
    <div class="phone-client" :class="{ 'valid' : phoneNumber.isValid,  'inValid': !phoneNumber.isValid }">
      <vue-tel-input
          v-model="phoneNumber.number"
          inputClasses="phone-input"
          defaultCountry='ru'
          placeholder='Введите номер телефона'
          :dynamicPlaceholder='false'
          :enabledCountryCode='false'
          :onlyCountries="['ru', 'ua', 'by']"
          :validCharactersOnly="true"
          :maxLen="13"
          @validate="onInputNumber"
      >
      </vue-tel-input>
      <i v-if="phoneNumber.isValid" class="material-icons">done</i>
    </div>

  </div>

</template>

<script>
    import { VueTelInput } from 'vue-tel-input'
    export default {
        name: "PhoneInput",
        components: {VueTelInput},
        data() {
            return {
                phoneNumber: {
                    isValid: false,
                    number: this.phone,
                },
                translation: {
                    countrySelectorLabel: '',
                    countrySelectorError: '',
                    phoneNumberLabel: '',
                    example: ''
                }
            }
        },
        props: {
            phone: String
        },
        methods: {
            onInputNumber({ number, isValid, country }) {
                this.phoneNumber.isValid = isValid;
                this.phoneNumber.number = number.e164;
                this.$emit('phoneChanged', this.phoneNumber);

            }
        }
    }
</script>

<style  lang="sass">
  .app_phone__input
    margin-bottom: 25px
    .vue-tel-input
      border: none
      width: 100%
      &:focus-within
        box-shadow: none
      .phone-input
        background-color: #f5f5f5
        border-radius: 0 8px 8px 0
    .phone-client
      display: flex
      align-items: center
      justify-content: space-between
      width: 100%
      margin: 10px 0 20px
      border: none
      border-bottom: 2px solid #000
      background-color: #f5f5f5
      border-radius: 8px
      &.valid
        border-color: #42b983
      &.inValid
        border-color: #ff3400
      i
        color: #42b983
    .vue-phone-number-input
      .country-selector
        &.has-value
          .country-selector
            &__input
              padding-top: 0
              border: none
              border-radius: 0
              border-bottom: 1px solid  #363636
              color: transparent
            &__country-flag
              top: 12px
          .input-tel__input
            border: none
            box-shadow: none
    .country-selector.is-focused .country-selector__input
      box-shadow: none
    .input-tel
      &.has-value
        .input-tel__input
          padding-top: 0
          border: none
          border-bottom: 1px solid  #363636
          border-radius: 0
      &.is-focused.is-valid
        .input-tel__input
          box-shadow: none
    .country-selector
      &.is-focused.is-valid
        .country-selector__input
          box-shadow: none
          -webkit-box-shadow: none
    .vue-phone-number-input
      .country-selector
        &.is-valid
          .country-selector__input
            border-bottom: 2px solid green
        &.has-value
          &:not(.is-valid)
            .country-selector__input
              border-bottom: 2px solid red
    .input-tel
      &.has-value
        &:not(.is-valid)
          .input-tel__input
            border-bottom: 2px solid red
        &.is-valid
          .input-tel__input
            border-bottom: 2px solid green
    .vti__dropdown
      padding-top: 1px
      padding-bottom: 1px
      &:hover
        border-radius: 8px
      &-item
        font-size: 12px
        display: block



</style>

